import { render, staticRenderFns } from "./ProfileAvatarList.vue?vue&type=template&id=0b0c6639&scoped=true"
import script from "./ProfileAvatarList.vue?vue&type=script&lang=js"
export * from "./ProfileAvatarList.vue?vue&type=script&lang=js"
import style0 from "./ProfileAvatarList.vue?vue&type=style&index=0&id=0b0c6639&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c6639",
  null
  
)

export default component.exports